export function hasPermission(permissionKey) {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return permissions.includes(permissionKey);
  } catch (error) {
    console.error("Error checking permission:", error);
    return false;
  }
}

export function hasAnyPermission(...keys) {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return keys.some((key) => permissions.includes(key));
  } catch {
    return false;
  }
}

export function hasAllPermissions(...keys) {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return keys.every((key) => permissions.includes(key));
  } catch {
    return false;
  }
}

// Check if user has any permission at all (for general access)
export function hasAnyPermissionAtAll() {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];
    return permissions.length > 0;
  } catch {
    return false;
  }
}
  
